import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { formatDate } from '../lib/utils';

/**
 * `useDateFormat()` returns a stable `(value) => string` formatter bound
 * to the current user's AMC `date_format` preference. Falls back to the
 * platform default (`DD-MMMM-YYYY`) whenever the user isn't scoped to an
 * AMC (e.g., Owner) or the preference hasn't loaded yet.
 *
 * Usage:
 *   const fmtDate = useDateFormat();
 *   <td>{fmtDate(row.date_of_transaction)}</td>
 */
export function useDateFormat() {
  const { user } = useAuth();
  const token = user?.amc_date_format || 'DD-MMMM-YYYY';
  return useCallback((value) => formatDate(value, token), [token]);
}
